import originalWithStyles from 'isomorphic-style-loader/withStyles';

type Params = Parameters<typeof originalWithStyles>;

export default function withStyles(...args: Params) {
  if (__WITH_STYLES__) {
    return originalWithStyles(...args);
  }
  return (x: any) => x;
}
